import { render, staticRenderFns } from "./PartnerMoves.vue?vue&type=template&id=98b4c2a4&scoped=true&"
import script from "./PartnerMoves.vue?vue&type=script&lang=js&"
export * from "./PartnerMoves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b4c2a4",
  null
  
)

export default component.exports